import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { parcelDeliveryType } from '../../types';

type parcelDeliveriesType = {
    parcel_deliveries: parcelDeliveryType [];
    is_loading_parcel_deliveries: boolean;
};
const initialState: parcelDeliveriesType = {
    parcel_deliveries: [],
    is_loading_parcel_deliveries: false,
};

const parcelDeliveriesSlice = createSlice({
    name: 'parcelDeliveries',
    initialState,
    reducers: {
        getParcelDeliveriesSuccess: (state, actions: PayloadAction<Array<parcelDeliveryType>>) => {
            return {
                ...state,
                parcel_deliveries: actions.payload
            };
        },
        setParcelDeliveriesLoading: (state, actions: PayloadAction<boolean>) => {
            return {
                ...state,
                is_loading_parcel_deliveries: actions.payload
            };
        },
    }
});

export const { getParcelDeliveriesSuccess, setParcelDeliveriesLoading } = parcelDeliveriesSlice.actions;

export default parcelDeliveriesSlice.reducer;